import * as Yup from 'yup'
import { imageInputSchema, imageNullInputSchema } from './commonSchma'

const createBookValidationSchema = Yup.object().shape({
  bookName: Yup.string().required('Book Name is required'),
  author: Yup.string().required('Author Name is required'),
  category: Yup.string().required('Please select a category'),
  desc: Yup.string().required('Description is required'),
  coverImg: imageInputSchema,
  images1: imageNullInputSchema,
  images2: imageNullInputSchema,
  images3: imageNullInputSchema,
  images4: imageNullInputSchema,
})
export default {
  createBookValidationSchema,
}
